import { render, staticRenderFns } from "./GeneralMetric.vue?vue&type=template&id=6b58766c&scoped=true&"
import script from "./GeneralMetric.vue?vue&type=script&lang=js&"
export * from "./GeneralMetric.vue?vue&type=script&lang=js&"
import style0 from "./GeneralMetric.vue?vue&type=style&index=0&id=6b58766c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b58766c",
  null
  
)

export default component.exports